import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import { IconX } from '@tabler/icons-react'
import { _showToast } from "../../../../../toastHelper";
  import ImageBrowse from "../../../../Common/Image/ImageBrowse";
import StepperNavigationButtons from "../../../MyInvitations/Common/StepperNavigationButtons";
  
const Background = forwardRef((props, ref) => {
    const [errors, setErrors] = useState({});
    const slide1ImageRef = useRef();
    const slide2ImageRef = useRef();
  
    const [slide1ImageKey, setSlide1ImageKey] = useState(null);
    const [slide2ImageKey, setSlide2ImageKey] = useState(null);
    const [file1, setFile1] = useState(null);
    const [file2, setFile2] = useState(null);
       
        
    useEffect(() => {
      resetData();
      if (props.data) {
        if (props.data.length > 0) {
          setSlide1ImageKey(props.data[0].imageKey);
          slide1ImageRef?.current?.setThumbnail(props.data[0].image);
          slide1ImageRef?.current?.setFileContent(props.data[0].imageFile);
        }
        if (props.data.length > 1) {
          setSlide2ImageKey(props.data[1].imageKey);
          slide2ImageRef?.current?.setThumbnail(props.data[1].image);
          slide2ImageRef?.current?.setFileContent(props.data[1].imageFile);
        }
      }
    }, [props.data]);
  
    const resetData = () => {
      slide1ImageRef?.current?.setThumbnail(null);
      slide1ImageRef?.current?.setFileContent(null);
      slide2ImageRef?.current?.setThumbnail(null);
      slide2ImageRef?.current?.setFileContent(null);
      setSlide1ImageKey(null);
      setSlide2ImageKey(null);
    };
  
    const validate = () => {
      const errors = {};
      setErrors(errors);
      return Object.keys(errors).length === 0;
    };
  
    const getData = () => {
      let sliders = [];
  
      if (slide1ImageRef?.current?.getThumbnail()) {
        
        sliders.push({
          image: slide1ImageRef?.current?.getThumbnail(),
          imageFile: slide1ImageRef?.current?.getImageFile(),
          imageKey: slide1ImageKey,
        });
      }
      if (slide2ImageRef?.current?.getThumbnail()) {
        
        sliders.push({
          image: slide2ImageRef?.current?.getThumbnail(),
          imageFile: slide2ImageRef?.current?.getImageFile(),
          imageKey: slide2ImageKey,
        });
      }
  
      return sliders;
    };
  
    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate,
    }));
    const handleCroppedImage1 = (file) => {
     setFile1(file)
     const sliders = [
      {image1: file,
      image2: file2,
    }]
  if (props.section) {
  props.section(sliders)
  }
    };
    const handleCroppedImage2 = (file) => {
     setFile2(file)
     const sliders = [
      {image1: file1,
      image2: file,
    }]
  if (props.section) {
  props.section(sliders)
  }
    };
    return (
      <div className="content d-block visible">
        <div className="content-header mb-3 d-flex justify-content-between flex-column flex-md-row">
          <div >
            <h2 className="text-primary">Sliders</h2>
            {/* <div className="title-shape"></div> */}
            <small className="fs-11 mb-0">You can set up to 2 banners, each file size should not exceed 1MB</small>
            <br />
            <small className="fs-11 mb-0">Dimension: 1920px x 844px</small>
          </div>
        </div>
        <div className="row g-3">
          {errors.noSlider && (
            <div style={{ color: "#ea5455", fontSize: "0.8125rem" }}>{errors.noSlider}</div>
          )}
          <div className="col-sm-6">
            <label className="form-label" htmlFor="slide1Image">Banner 1</label>
            <ImageBrowse 
              elementId="slide1Image" 
              ref={slide1ImageRef} 
              imageType="background"
              imageKey={slide1ImageKey} 
              setImageKey={setSlide1ImageKey} 
              imageDelete={props.imageDelete} 
              onImageCropped={handleCroppedImage1}
            />
          </div>
          <div className="col-sm-6">
            <label className="form-label" htmlFor="slide2Image">Banner 2</label>
            <ImageBrowse 
              elementId="slide2Image" 
              ref={slide2ImageRef} 
              imageType="background"
              imageKey={slide2ImageKey} 
              setImageKey={setSlide2ImageKey} 
              imageDelete={props.imageDelete} 
              onImageCropped={handleCroppedImage2}
  
            />
          </div>
          <StepperNavigationButtons index={props.index} steps={props.steps} navigate={props.navigate} save={props.save} />
        </div>
      </div>
    );
  });
  
  export default Background;
  